module.exports = __webpack_public_path__ + "img/house.36d9f43a.png";